import gql from 'graphql-tag';
import { compose, graphql } from 'react-apollo';

import RecoverPw from './RecoverPw';

const RecoverPwMutation = gql`
  mutation resetPassword($token: String!, $newPassword: String!) {
    resetPassword(token: $token, newPassword: $newPassword)
  }
`;

interface IInputProps {
  children?: any;
}

interface IResponse {
  data: any;
}

export default compose(
  graphql<IInputProps, IResponse>(RecoverPwMutation, {
    name: 'resetPassword'
  })
)(RecoverPw);



// WEBPACK FOOTER //
// ./src/components/Query/User/RecoverPw/index.tsx